import { useMemo } from 'react';

import { useBreakPoints } from '@/package';

export const useBreakPoint = () => {
  const breakPointConfig = useMemo(
    () => ({
      desktop: 1440,
      largeDesktop: 1920,
    }),
    [],
  );

  const breakPoint = useBreakPoints({
    breakPoint: breakPointConfig,
  });

  return breakPoint;
};
